import React, { FC, useState } from "react";
import "../../assets/style/3_components/c-playbackInformation.scss";
import { NextFrameIcon, PauseIcon, PlaybackRateIcon, PlayIcon, PrevFrameIcon } from "../icons";

type Props = {
  isPlaying: boolean;
  className?: string;
  style?: React.CSSProperties;
  onPlay: () => void;
  onPause: () => void;
  onGoToNextFrame: () => void;
  onGoToPreviousFrame: () => void;
  onPlaybackSpeedChange: (playbackRate: number) => void;
};

const valueToPlaybackSpeed = (value: number) => {
  return value * 0.25 + 0.25;
};

export const DebugControls: FC<Props> = (props) => {
  const { className, style, isPlaying, onPlay, onPause, onPlaybackSpeedChange, onGoToNextFrame, onGoToPreviousFrame } = props;

  const [playbackSpeed, setPlaybackSpeed] = useState(3);

  return (
    <div className={`c-debugControls ${className || ""}`} style={style || {}}>
      <div className="c-debugControls__media">
        <button onClick={onGoToPreviousFrame} className="c-debugControls__button">
          <PrevFrameIcon className="c-debugControls__prevIcon" />
        </button>
        <button onClick={isPlaying ? onPause : onPlay} className="c-debugControls__button">
          {isPlaying ? <PauseIcon className={"c-debugControls__playIcon"} /> : <PlayIcon className={"c-debugControls__playIcon"} />}
        </button>
        <button onClick={onGoToNextFrame} className="c-debugControls__button">
          <NextFrameIcon className={"c-debugControls__nextIcon"} />
        </button>
      </div>
      <div className="c-debugControls__playbackRate">
        <div className="c-debugControls__playbackRateValue">
          <PlaybackRateIcon />
          {valueToPlaybackSpeed(playbackSpeed).toFixed(2) + "x"}
        </div>
        <div className="c-debugControls__playbackRateSlider">
          <input
            type="range"
            min={0}
            max={11}
            step={1}
            onChange={(e) => {
              setPlaybackSpeed(e.target.valueAsNumber);
              onPlaybackSpeedChange(valueToPlaybackSpeed(e.target.valueAsNumber));
            }}
            value={playbackSpeed}
          />
        </div>
      </div>
    </div>
  );
};
